import { type LabelValuePair } from '../types';

export const jaNeeOptions: Array<LabelValuePair<boolean>> = [
  { label: 'Ja', value: true },
  { label: 'Nee', value: false },
];
